<div class="row rounded-card" id="pattern-settings">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="pattern-title">{{ 'SYSTEM_SETTINGS.MODULES.PATTERNS_SETTINGS_TITLE' | translate }}</h2>
      <span class="text-base">{{ 'SYSTEM_SETTINGS.MODULES.PATTERNS_SETTINGS_SUBTITLE' | translate }}</span>
    </div>
    <div class="flex items-center gap-2">
      <button data-testid="add-pattern-btn" class="btn primary-btn" (click)="displayCreatePatternModalbox()">Add pattern</button>
    </div>
  </div>
  <hr class="mb-1 mt-2 border-t">
  <section>
    <div class="col-12 mt-4">
      <p-table [value]="data">
        <ng-template #header>
          <tr>
            <th>
              <div class="header-wr">
                <span data-testid="pattern-type-header" class="col-name">Pattern Type</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="pattern-value-header" class="col-name">Pattern value</span>
              </div>
            </th>
            <th>
              <div class="header-wr">
                <span data-testid="pattern-actions-header" class="col-name">Actions</span>
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-pattern let-rowIndex="rowIndex">
          <tr [attr.data-id]="pattern.id">
            <td>
              <span class="p-column-title">Pattern Type:</span>
              <span [attr.data-testid]="'pattern-type-' + rowIndex">{{ pattern.regularExpressionType | defaultValue }}</span>
            </td>
            <td>
              <span class="p-column-title">Pattern value:</span>
              <span [attr.data-testid]="'pattern-pattern-' + rowIndex">{{ pattern.pattern | defaultValue }}</span>
            </td>
            <td class="actions-col">
              <div class="actions gap-2">
                <p-toggleswitch class="centred" [(ngModel)]="pattern.isActive" (onChange)="onStateChange($event, pattern)"
                [attr.data-testid]="'switch-' + rowIndex" />
                <button type="button" pTooltip="View" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-edit" (click)="onViewPattern($event, pattern)" [attr.data-testid]="'edit-' + rowIndex">
                  <span class="btn-label">Edit</span>
                </button>
                <button type="button" pTooltip="Remove pattern" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-remove" (click)="onRemovePattern($event, pattern.id)" [attr.data-testid]="'remove-' + rowIndex">
                  <span class="btn-label">Remove pattern</span>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="4">No patterns set yet.</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Pagination -->
      <app-custom-paginator
        data-testid="paginator"
        [first]="paginatorFirst"
        [rows]="paginatorRows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 20, 50]"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
        [disabled]="totalRecords === 0"
        [alwaysShow]="true"
        [showFirstLastIcon]="true"
        [showPageLinks]="true"
        [showPageSizeSelector]="true"
        (onPageChange)="onPageChange($event)">
      </app-custom-paginator>
    </div>
  </section>
</div>

<!-- Modalbox: Create pattern -->
<p-dialog [(visible)]="showCreatePatternModal" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="true" [style]="{ height: 'auto' }" [dismissableMask]="true" [header]="'New pattern'" [styleClass]="'overflow-y-visible'">
  <form class="mt-0" [formGroup]="patternForm">
    <div class="row">
      <div class="field-wr flex flex-col col-12 col-md-4 mb-3 mt-1">
        <label class="block text-sm" for="">Pattern Type<i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="create-pattern-type"
          [options]="patternTypeOptions"
          optionLabel="value"
          optionValue="value"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [showSearchbox]="false"
          [searchMode]="'local'"
          [pageSize]="patternTypeRowsPerPageOption"
          [totalCount]="patternTypeTotalRecords"
          [totalPages]="getPatternTypeTotalPages()"
          formControlName="regularExpressionType"
          [placeholder]="'Select a pattern Type'">
        </app-custom-dropdown>
        @if (patternForm.get('regularExpressionType')?.invalid && patternForm.get('regularExpressionType')?.touched) {
          <small data-testid="patterntype-mandatory" class="p-error">
            {{ 'FORMS.MANDATORY_FIELD' | translate }}
          </small>
        }
      </div>
      <div class="field-wr flex flex-col col-12 col-md-8 mb-3">
        <label class="block text-sm" for="">Regular expression pattern<i class="icon-required-field"></i></label>
        <input type="text" formControlName="pattern" autocomplete="off" />
        @if ( patternForm.get('pattern')?.invalid && patternForm.get('pattern')?.touched) {
          <small data-testid="pattern-mandatory" class="p-error">
            {{ 'FORMS.MANDATORY_FIELD' | translate }}
          </small>
        }
      </div>
    </div>
  </form>

  <ng-template #footer>
    <button type="button" class="btn outline-btn" (click)="cancelCreatePattern()">Cancel</button>
    <button type="button" class="btn primary-btn" [disabled]="patternForm.invalid"
      (click)="createPattern()">Create pattern</button>
  </ng-template>
</p-dialog>

<!-- Modalbox: Update pattern -->
<p-dialog [(visible)]="showViewPatternModal" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="false" [style]="{ height: '30rem' }" [dismissableMask]="true" [header]="'Update pattern'">
  <form class="mt-0" [formGroup]="updatePatternForm">
    <div class="row">
      <div class="field-wr flex flex-col col-12 col-md-4 mb-3 mt-1">
        <label class="block text-sm" for="">Pattern Type<i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="update-pattern-type"
          [options]="patternTypeOptions"
          optionLabel="value"
          optionValue="value"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [showSearchbox]="false"
          [searchMode]="'local'"
          [pageSize]="patternTypeRowsPerPageOption"
          [totalCount]="patternTypeTotalRecords"
          [totalPages]="getPatternTypeTotalPages()"
          formControlName="regularExpressionType"
          [placeholder]="'Select a pattern Type'">
        </app-custom-dropdown>
      </div>
      <div class="field-wr flex flex-col col-12 col-md-8 mb-3">
        <label class="block text-sm" for="">Regular expression pattern<i class="icon-required-field"></i></label>
        <input type="text" formControlName="pattern" autocomplete="off" />
      </div>
    </div>
  </form>

  <ng-template #footer>
    <button type="button" class="btn outline-btn" (click)="cancelViewPattern()">Cancel</button>
    <button type="button" class="btn primary-btn" [disabled]="updatePatternForm.invalid"
      (click)="savePattern()">Update pattern</button>
  </ng-template>
</p-dialog>
